module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_10.09021a92.jpg";